// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.


import 'babel-polyfill';
import "@babel/polyfill";
import promise from 'es6-promise'
promise.polyfill();

import Vue from 'vue'
import App from './App'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import router from './router'
import axios from 'axios'; /* 引入axios进行地址访问*/
Vue.prototype.$http = axios;
Vue.use(ElementUI)

import comm from "./assets/js/public";
Vue.config.productionTip = false;
import "@/assets/css/public.css";
require("es6-promise").polyfill();
import echarts from 'echarts'
import animated from 'animate.css'
import VueTouch from 'vue-touch'
Vue.use(VueTouch, {name: 'v-touch'})
import { VueHammer } from 'vue2-hammer'
Vue.use(VueHammer)

import JsonExcel from "vue-json-excel"
Vue.component("downloadExcel",JsonExcel)


Vue.prototype.$echarts = echarts
Vue.config.productionTip = false
Vue.use(animated)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js